<template>
  <div class="container-fluid">
    <div class="page-title">
      <div class="row">
        <div class="col-6">
          <h3>Dar de alta un viajero</h3>
        </div>
      </div>
    </div>

    <ClienteForm
      role="CONDUCTOR_VIAJERO"
      title="Registrar viajero"
      subtitle="Completa el formulario para dar de alta un conductor viajero."
      submit-label="Dar de alta viajero"
      name-placeholder="Nombre del viajero"
      success-title="Viajero creado"
    />
  </div>
</template>

<script>
import ClienteForm from '@/components/clientes/ClienteForm.vue';

export default {
  name: 'AltaViajero',
  components: { ClienteForm },
};
</script>

